exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flights-search{max-width:1240px;width:100%}@media screen and (min-width:1240px){.flights-search{margin:30px auto}}.flights-search .search-card{padding:1.25rem 0;border-radius:1rem}@media (min-width:992px){.flights-search .search-card{background-color:#fff;padding-left:.5rem;padding-right:.5rem;padding-bottom:.4rem}}.flights-search .floating-container{position:absolute;padding:3rem 1rem 1.25rem;left:0;bottom:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:flex-end}@media (min-width:992px){.flights-search .floating-container{padding:2.5rem}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};